/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Faq4q1Inputs */

const zh_pricing_faq4q1 = /** @type {(inputs: Pricing_Faq4q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max 计划支持多少人？`)
};

const en_pricing_faq4q1 = /** @type {(inputs: Pricing_Faq4q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How many people does the Max plan support?`)
};

const es_pricing_faq4q1 = /** @type {(inputs: Pricing_Faq4q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuántas personas soporta el plan Max?`)
};

/**
* | output |
* | --- |
* | "How many people does the Max plan support?" |
*
* @param {Pricing_Faq4q1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const pricing_faq4q1 = /** @type {((inputs?: Pricing_Faq4q1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Faq4q1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_pricing_faq4q1(inputs)
	if (locale === "en") return en_pricing_faq4q1(inputs)
	return es_pricing_faq4q1(inputs)
});
export { pricing_faq4q1 as "pricing_faq4Q" }